<script>
  import { getContext, onMount, tick } from "svelte";
  import PasswordBox from "./PasswordBox.svelte";

  const { open } = getContext("password-modal");

  onMount(async () => {
    await tick();
    open(PasswordBox);
  });
</script>
